import { render } from "./CIS-Resource-GenericPage.vue?vue&type=template&id=c5b38eb0&scoped=true"
import script from "./CIS-Resource-GenericPage.vue?vue&type=script&lang=js"
export * from "./CIS-Resource-GenericPage.vue?vue&type=script&lang=js"

import "./CIS-Resource-GenericPage.vue?vue&type=style&index=0&id=c5b38eb0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5b38eb0"]])

export default __exports__